import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { commissionQueries } from '@/services/commissions/commissions.queries';

export const useCommissionDetail = (categoryId: string | undefined) => {
  const { data, isLoading } = useQuery({
    ...commissionQueries.detail(categoryId || ''),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
    enabled: Boolean(categoryId),
  });

  return { commissionsDetail: data?.data ?? null, isLoading };
};
